

import React, { useState, useEffect } from 'react';
import {Box,Container,Paper,Typography,Button,TextField,Table,TableBody,TableCell,TableContainer,TableHead,TableRow,IconButton,Chip,
  Dialog,DialogTitle,DialogContent,DialogActions,Grid,Card,CardContent,MenuItem,Select,FormControl,InputLabel,Tooltip,Alert,Snackbar,CircularProgress,
  List, ListItem, ListItemIcon, ListItemText, Divider, Stack, InputAdornment 
} from '@mui/material';
import {Add,Edit,Delete,Visibility,Search,FilterList,Verified,Block,Phone,Email,LocationOn,CheckCircle,Cancel, AccountBalanceWallet, History, Payments
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { apiRequest } from '../../fetchSetup';

const DistributorList = () => {
  const navigate = useNavigate();
  const [distributors, setDistributors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');
  const [filterType, setFilterType] = useState('');
  const [filterActive, setFilterActive] = useState('all');
  const [stats, setStats] = useState({
    total: 0,
    active: 0,
    verified: 0,
    blacklisted: 0
  });
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [selectedDistributor, setSelectedDistributor] = useState(null);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

  const DRAWER_WIDTH = '280px';
function money(n) {
  const v = Number(n || 0);
  return `₹${v.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

// --- Wallet dialog state ---
const [walletDialog, setWalletDialog] = useState(false);
const [walletDistributor, setWalletDistributor] = useState(null);
const [walletData, setWalletData] = useState({ credit_balance: 0, ledger: [] });
const [walletLoading, setWalletLoading] = useState(false);
const [walletError, setWalletError] = useState('');

const [useAmount, setUseAmount] = useState('');
const [usePoNumber, setUsePoNumber] = useState('');
const [useNotes, setUseNotes] = useState('');
const [useSubmitting, setUseSubmitting] = useState(false);
const [useError, setUseError] = useState('');
const [walletBalances, setWalletBalances] = useState({}); // { [distributor_id]: number }
const [walletBalancesLoading, setWalletBalancesLoading] = useState({}); // { [distributor_id]: bool }
const [pendingPayables, setPendingPayables] = useState({ total_pending_payable: 0, payables: [] });
const [payablesLoading, setPayablesLoading] = useState(false);
const [payingId, setPayingId] = useState(null);

  useEffect(() => {
    fetchDistributors();
    fetchStats();
  }, [searchQuery, filterType, filterActive]);
useEffect(() => {
  if (distributors.length === 0) return;
  distributors.forEach((dist) => {
    fetchBalanceForRow(dist.distributor_id);
  });
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [distributors]);


const fetchBalanceForRow = async (distributorId) => {
  setWalletBalancesLoading((prev) => ({ ...prev, [distributorId]: true }));
  try {
    const response = await apiRequest(
      `${VENDOR_RETURN_API}/distributors/${distributorId}/credit`
    );
    const data = await response.json();
    setWalletBalances((prev) => ({ ...prev, [distributorId]: data.net_balance ?? data.credit_balance ?? 0 }));
  } catch (error) {
    console.error('Error fetching balance for', distributorId, error);
    setWalletBalances((prev) => ({ ...prev, [distributorId]: 0 }));
  } finally {
    setWalletBalancesLoading((prev) => ({ ...prev, [distributorId]: false }));
  }
};

  const fetchDistributors = async () => {
    try {
      setLoading(true);
      const params = new URLSearchParams();
      
      if (searchQuery) params.append('search', searchQuery);
      if (filterType) params.append('distributor_type', filterType);
      if (filterActive !== 'all') params.append('is_active', filterActive === 'active');

      const response = await apiRequest(
        `${process.env.REACT_APP_API}/distributors?${params.toString()}`
      );
      const data = await response.json();
      setDistributors(data.distributors || []);
    } catch (error) {
      console.error('Error fetching distributors:', error);
      showSnackbar('Error fetching distributors', 'error');
    } finally {
      setLoading(false);
    }
  };

  const fetchStats = async () => {
    try {
      const response = await apiRequest(`${process.env.REACT_APP_API}/distributors/stats`);
      const data = await response.json();
      setStats(data);
    } catch (error) {
      console.error('Error fetching stats:', error);
    }
  };

  const showSnackbar = (message, severity = 'success') => {
    setSnackbar({ open: true, message, severity });
  };
  const VENDOR_RETURN_API = process.env.REACT_APP_VENDER_RETURN_API_URL;


const openWalletDialog = async (distributor) => {
  setWalletDistributor(distributor);
  setWalletDialog(true);
  setUseAmount(''); setUsePoNumber(''); setUseNotes(''); setUseError('');
  await fetchWalletData(distributor.distributor_id);
};


const fetchWalletData = async (distributorId) => {
  setWalletLoading(true);
  setWalletError('');
  try {
    const response = await apiRequest(
      `${VENDOR_RETURN_API}/distributors/${distributorId}/credit`
    );
    const data = await response.json();
    if (!response.ok) throw new Error(data.error || 'Failed to load wallet');
    setWalletData({
      credit_balance: data.credit_balance || 0,
      ledger: data.ledger || [],
    });
    setPendingPayables({
      total_pending_payable: data.total_pending_payable || 0,
      payables: data.payables || [],
    });
  } catch (error) {
    console.error('Error fetching wallet:', error);
    setWalletError(error.message || 'Could not load wallet balance');
  } finally {
    setWalletLoading(false);
  }
};


const fetchPendingPayables = async (distributorId) => {
  setPayablesLoading(true);
  try {
    const response = await apiRequest(
      `${VENDOR_RETURN_API}/distributors/${distributorId}/pending-payables`
    );
    const data = await response.json();
    if (response.ok) setPendingPayables(data);
  } catch (error) {
    console.error('Error fetching pending payables:', error);
  } finally {
    setPayablesLoading(false);
  }
};

const handleMarkPayablePaid = async (returnId, settlementId) => {
  setPayingId(settlementId);
  try {
    const response = await apiRequest(
      `${VENDOR_RETURN_API}/vendor-returns/${returnId}/settlements/${settlementId}/excess-payment`,
      {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({}),
      }
    );
    const data = await response.json();
    if (!response.ok) throw new Error(data.error || 'Failed to mark as paid');
    showSnackbar('Marked as paid');
    await fetchWalletData(walletDistributor.distributor_id);
    await fetchBalanceForRow(walletDistributor.distributor_id); // update the table chip too
  } catch (error) {
    showSnackbar(error.message, 'error');
  } finally {
    setPayingId(null);
  }
};




const handleUseCredit = async () => {
  setUseError('');
  const amt = Number(useAmount);
  if (!amt || amt <= 0) {
    setUseError('Enter a valid amount.');
    return;
  }
  if (amt > (walletData.credit_balance || 0) + 0.01) {
    setUseError(`Amount exceeds available credit (${money(walletData.credit_balance)}).`);
    return;
  }
  setUseSubmitting(true);
  try {
    const response = await apiRequest(
      `${VENDOR_RETURN_API}/distributors/${walletDistributor.distributor_id}/credit/use`,
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          amount: amt,
          po_number: usePoNumber,
          notes: useNotes,
        }),
      }
    );
    const data = await response.json();
    if (!response.ok) throw new Error(data.error || 'Failed to use credit');

    showSnackbar(`${money(amt)} credit applied. Remaining: ${money(data.remaining_credit)}`);
    setUseAmount(''); setUsePoNumber(''); setUseNotes('');
    await fetchWalletData(walletDistributor.distributor_id); // refresh balance + ledger
  } catch (error) {
    setUseError(error.message);
  } finally {
    setUseSubmitting(false);
  }
};

  const handleDelete = async () => {
    try {
      const response = await apiRequest(
        `${process.env.REACT_APP_API}/distributors/${selectedDistributor.distributor_id}`,
        { method: 'DELETE' }
      );

      if (response.ok) {
        showSnackbar('Distributor deleted successfully');
        fetchDistributors();
        fetchStats();
        setDeleteDialog(false);
        setSelectedDistributor(null);
      } else {
        const error = await response.json();
        showSnackbar(error.error || 'Failed to delete distributor', 'error');
      }
    } catch (error) {
      console.error('Error deleting distributor:', error);
      showSnackbar('Error deleting distributor', 'error');
    }
  };

  const handleStatusToggle = async (distributor) => {
    try {
      const response = await apiRequest(
        `${process.env.REACT_APP_API}/distributors/${distributor.distributor_id}/status`,
        {
          method: 'PATCH',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ is_active: !distributor.is_active })
        }
      );

      if (response.ok) {
        showSnackbar(`Distributor ${!distributor.is_active ? 'activated' : 'deactivated'} successfully`);
        fetchDistributors();
        fetchStats();
      } else {
        showSnackbar('Failed to update status', 'error');
      }
    } catch (error) {
      console.error('Error updating status:', error);
      showSnackbar('Error updating status', 'error');
    }
  };

  const handleVerify = async (distributorId) => {
    try {
      const response = await apiRequest(
        `${process.env.REACT_APP_API}/distributors/${distributorId}/verify`,
        { method: 'POST' }
      );

      if (response.ok) {
        showSnackbar('Distributor verified successfully');
        fetchDistributors();
        fetchStats();
      } else {
        showSnackbar('Failed to verify distributor', 'error');
      }
    } catch (error) {
      console.error('Error verifying distributor:', error);
      showSnackbar('Error verifying distributor', 'error');
    }
  };

  const openDeleteDialog = (distributor) => {
    setSelectedDistributor(distributor);
    setDeleteDialog(true);
  };

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#f5f5f5', ml: { xs: 0, md: DRAWER_WIDTH } }}>
      <Container maxWidth="xl" sx={{ py: 4 }}>
        {/* Header */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
          <Typography variant="h4" sx={{ fontWeight: 700, color: '#0F172A' }}>
            Distributors
          </Typography>
          <Button
            variant="contained"
            startIcon={<Add />}
            onClick={() => navigate('/distributors/add')}
            sx={{
              bgcolor: '#006D77',textTransform:"none",
              '&:hover': { bgcolor: '#005962' }
            }}
          >
            Add Distributor
          </Button>
        </Box>

        {/* Stats Cards */}
        <Grid container spacing={3} sx={{ mb: 3 }}>
          <Grid item xs={12} sm={6} md={3}>
            <Card>
              <CardContent>
                <Typography color="textSecondary" gutterBottom>
                  Total Distributors
                </Typography>
                <Typography variant="h4" sx={{ fontWeight: 700, color: '#006D77' }}>
                  {stats.total}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Card>
              <CardContent>
                <Typography color="textSecondary" gutterBottom>
                  Active
                </Typography>
                <Typography variant="h4" sx={{ fontWeight: 700, color: '#4caf50' }}>
                  {stats.active}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Card>
              <CardContent>
                <Typography color="textSecondary" gutterBottom>
                  Verified
                </Typography>
                <Typography variant="h4" sx={{ fontWeight: 700, color: '#2196f3' }}>
                  {stats.verified}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Card>
              <CardContent>
                <Typography color="textSecondary" gutterBottom>
                  Blacklisted
                </Typography>
                <Typography variant="h4" sx={{ fontWeight: 700, color: '#f44336' }}>
                  {stats.blacklisted}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        {/* Filters */}
        <Paper sx={{ p: 2, mb: 3 }}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                sx={{
                  width: {
                    xs: '100%',
                    sm: 400,
                    md: 500,
                  },
                }}
                placeholder="Search distributors..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                InputProps={{
                  startAdornment: <Search sx={{ mr: 1, color: '#666' }} />
                }}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <FormControl fullWidth
               sx={{
                width: {
                  xs: '100%',
                  sm: 100,
                  md: 300,
                },
              }}>
                <InputLabel>Type</InputLabel>
                <Select
                  value={filterType}
                  onChange={(e) => setFilterType(e.target.value)}
                  label="Type"
                >
                  <MenuItem value="">All Types</MenuItem>
                  <MenuItem value="distributor">Distributor</MenuItem>
                  <MenuItem value="manufacturer">Manufacturer</MenuItem>
                  <MenuItem value="wholesaler">Wholesaler</MenuItem>
                  <MenuItem value="importer">Importer</MenuItem>
                  <MenuItem value="local_vendor">Local Vendor</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={3}>
              <FormControl fullWidth
               sx={{
                width: {
                  xs: '100%',
                  sm: 100,
                  md: 300,
                },
              }}>
                <InputLabel>Status</InputLabel>
                <Select
                  value={filterActive}
                  onChange={(e) => setFilterActive(e.target.value)}
                  label="Status"
                >
                  <MenuItem value="all">All Status</MenuItem>
                  <MenuItem value="active">Active</MenuItem>
                  <MenuItem value="inactive">Inactive</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </Paper>

        {/* Table */}
        <TableContainer component={Paper}>
          {loading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
              <CircularProgress />
            </Box>
          ) : (
            <Table>
              <TableHead sx={{ bgcolor: '#f5f5f5' }}>
                <TableRow>
                  <TableCell sx={{ fontWeight: 700 }}>Code</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>Name</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>Type</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>Contact</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>Payment Terms</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>Status</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>Actions</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>Wallet</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {distributors.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={7} align="center">
                      <Typography color="textSecondary">No distributors found</Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  distributors.map((dist) => (
                    <TableRow key={dist.distributor_id} hover>
                      <TableCell>
                        <Typography variant="body2" sx={{ fontWeight: 600 }}>
                          {dist.distributor_code}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Box>
                          <Typography variant="body1" sx={{ fontWeight: 600 }}>
                            {dist.name}
                          </Typography>
                          <Typography variant="caption" color="textSecondary">
                            {dist.company_name}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Chip
                          label={dist.distributor_type}
                          size="small"
                          sx={{ textTransform: 'capitalize' }}
                        />
                      </TableCell>
                      <TableCell>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            <Phone sx={{ fontSize: 14, color: '#666' }} />
                            <Typography variant="caption">{dist.phone || 'N/A'}</Typography>
                          </Box>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            <Email sx={{ fontSize: 14, color: '#666' }} />
                            <Typography variant="caption">{dist.email || 'N/A'}</Typography>
                          </Box>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2" sx={{ textTransform: 'capitalize' }}>
                          {dist.payment_terms?.replace('_', ' ') || 'N/A'}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                          <Chip
                            label={dist.is_active ? 'Active' : 'Inactive'}
                            size="small"
                            color={dist.is_active ? 'success' : 'default'}
                            icon={dist.is_active ? <CheckCircle /> : <Cancel />}
                          />
                          {dist.is_verified && (
                            <Chip
                              label="Verified"
                              size="small"
                              color="info"
                              icon={<Verified />}
                            />
                          )}
                          {dist.blacklisted && (
                            <Chip
                              label="Blacklisted"
                              size="small"
                              color="error"
                              icon={<Block />}
                            />
                          )}
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box sx={{ display: 'flex', gap: 0.5 }}>
                          <Tooltip title="View Details">
                            <IconButton
                              size="small"
                              onClick={() => navigate(`/distributors/${dist.distributor_id}`)}
                              sx={{ color: '#006D77' }}
                            >
                              <Visibility fontSize="small" />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Edit">
                            <IconButton
                              size="small"
                              onClick={() => navigate(`/distributors/edit/${dist.distributor_id}`)}
                              sx={{ color: '#2196f3' }}
                            >
                              <Edit fontSize="small" />
                            </IconButton>
                          </Tooltip>
                          {!dist.is_verified && (
                            <Tooltip title="Verify">
                              <IconButton
                                size="small"
                                onClick={() => handleVerify(dist.distributor_id)}
                                sx={{ color: '#4caf50' }}
                              >
                                <Verified fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          )}
                          <Tooltip title={dist.is_active ? 'Deactivate' : 'Activate'}>
                            <IconButton
                              size="small"
                              onClick={() => handleStatusToggle(dist)}
                              sx={{ color: dist.is_active ? '#ff9800' : '#4caf50' }}
                            >
                              {dist.is_active ? <Cancel fontSize="small" /> : <CheckCircle fontSize="small" />}
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Delete">
                            <IconButton
                              size="small"
                              onClick={() => openDeleteDialog(dist)}
                              sx={{ color: '#f44336' }}
                            >
                              <Delete fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      </TableCell>

                      <TableCell>
                          {walletBalancesLoading[dist.distributor_id] ? (
                            <CircularProgress size={16} sx={{ color: '#8e24aa' }} />
                          ) : (
                    
                            <Chip
                                icon={<AccountBalanceWallet sx={{ fontSize: 16 }} />}
                                label={
                                  (walletBalances[dist.distributor_id] || 0) < 0
                                    ? `-${money(Math.abs(walletBalances[dist.distributor_id]))}`
                                    : money(walletBalances[dist.distributor_id] || 0)
                                }
                                size="small"
                                onClick={() => openWalletDialog(dist)}
                                clickable
                                sx={{
                                  fontWeight: 700,
                                  bgcolor:
                                    (walletBalances[dist.distributor_id] || 0) > 0 ? '#f3e5f5'
                                    : (walletBalances[dist.distributor_id] || 0) < 0 ? '#FEEBEE'
                                    : '#f5f5f5',
                                  color:
                                    (walletBalances[dist.distributor_id] || 0) > 0 ? '#8e24aa'
                                    : (walletBalances[dist.distributor_id] || 0) < 0 ? '#C62828'
                                    : '#999',
                                  '&:hover': { bgcolor: (walletBalances[dist.distributor_id] || 0) < 0 ? '#FFCDD2' : '#e1bee7' },
                                }}
                              />
                          )}
                        </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          )}
        </TableContainer>
      </Container>

      {/* Delete Confirmation Dialog */}
      <Dialog open={deleteDialog} onClose={() => setDeleteDialog(false)}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to delete distributor "{selectedDistributor?.name}"?
            This will deactivate the distributor.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteDialog(false)}>Cancel</Button>
          <Button onClick={handleDelete} color="error" variant="contained">
            Delete
          </Button>
        </DialogActions>
      </Dialog>


      {/* Wallet / Credit Dialog */}
<Dialog open={walletDialog} onClose={() => setWalletDialog(false)} maxWidth="sm" fullWidth>
  <DialogTitle sx={{ bgcolor: '#006D77', color: 'white', display: 'flex', alignItems: 'center', gap: 1 }}>
    <AccountBalanceWallet />
    {walletDistributor?.name || walletDistributor?.company_name} — Wallet
  </DialogTitle>

  <DialogContent dividers sx={{ p: 3 }}>
    {walletLoading ? (
      <Box sx={{ textAlign: 'center', py: 4 }}>
        <CircularProgress size={32} sx={{ color: '#006D77' }} />
      </Box>
    ) : walletError ? (
      <Alert severity="error">{walletError}</Alert>
    ) : (
      <>
        {/* Balance */}
        <Paper
          variant="outlined"
          sx={{ p: 2.5, mb: 3, borderRadius: 2, textAlign: 'center', bgcolor: '#f3e5f5' }}
        >
          <Typography variant="caption" color="text.secondary" sx={{ textTransform: 'uppercase' }}>
            Available Credit Balance
          </Typography>
          <Typography variant="h4" fontWeight={800} sx={{ color: '#8e24aa', mt: 0.5 }}>
            {money(walletData.credit_balance)}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            Amount owed to this distributor — apply it to any future purchase order
          </Typography>
        {/* </Paper> */}
        </Paper>

        {pendingPayables.total_pending_payable > 0 && (
          <Paper variant="outlined" sx={{ p: 2.5, mb: 3, borderRadius: 2, bgcolor: '#FEEBEE', border: '1px solid #F8BBD0' }}>
            <Typography variant="caption" color="text.secondary" sx={{ textTransform: 'uppercase' }}>
              Amount you owe this distributor
            </Typography>
            <Typography variant="h4" fontWeight={800} sx={{ color: '#C62828', mt: 0.5 }}>
              {money(pendingPayables.total_pending_payable)}
            </Typography>
            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 2 }}>
              From replacement settlements whose value exceeded the return's outstanding balance
            </Typography>

            {payablesLoading ? (
              <Box sx={{ textAlign: 'center', py: 2 }}><CircularProgress size={20} /></Box>
            ) : (
              <List disablePadding>
                {pendingPayables.payables.map((p) => (
                  <ListItem key={p.settlement_id} divider sx={{ px: 0 }}
                    secondaryAction={
                      <Button
                        size="small" variant="contained" disabled={payingId === p.settlement_id}
                        onClick={() => handleMarkPayablePaid(p.return_id, p.settlement_id)}
                        sx={{ bgcolor: '#C62828', '&:hover': { bgcolor: '#921E1E' } }}
                      >
                        {payingId === p.settlement_id ? <CircularProgress size={16} color="inherit" /> : 'Mark as paid'}
                      </Button>
                    }
                  >
                    <ListItemText
                      primary={
                        <Stack direction="row" justifyContent="space-between" sx={{ pr: 12 }}>
                          <Typography variant="body2" fontWeight={600}>{p.replacement_medicine_name}</Typography>
                          <Typography variant="body2" fontWeight={700} sx={{ color: '#C62828' }}>
                            {money(p.excess_pending_amount)}
                          </Typography>
                        </Stack>
                      }
                      secondary={
                        <Typography variant="caption" color="text.secondary">
                          Return {p.return_id} · replacement {money(p.replacement_value)}
                          {p.excess_covered_by_credit > 0 && ` · ${money(p.excess_covered_by_credit)} covered by credit`}
                        </Typography>
                      }
                    />
                  </ListItem>
                ))}
              </List>
            )}
          </Paper>
        )}

       

        {/* Use credit form */}
        <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 1.5 }}>
          Use credit against a purchase
        </Typography>
        <Grid container spacing={1.5} sx={{ mb: 1.5 }}>
          <Grid item xs={6}>
            <TextField
              fullWidth size="small" type="number" label="Amount to use"
              value={useAmount} onChange={(e) => setUseAmount(e.target.value)}
              placeholder={`Up to ${walletData.credit_balance.toFixed(2)}`}
              InputProps={{ startAdornment: <InputAdornment position="start">₹</InputAdornment> }}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth size="small" label="PO number (optional)"
              value={usePoNumber} onChange={(e) => setUsePoNumber(e.target.value)}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth size="small" label="Notes (optional)"
              value={useNotes} onChange={(e) => setUseNotes(e.target.value)}
            />
          </Grid>
        </Grid>

        {useError && <Alert severity="error" sx={{ mb: 1.5 }}>{useError}</Alert>}

        <Button
          fullWidth variant="contained" disabled={useSubmitting || walletData.credit_balance <= 0}
          onClick={handleUseCredit}
          startIcon={useSubmitting ? <CircularProgress size={16} color="inherit" /> : <Payments />}
          sx={{ bgcolor: '#8e24aa', '&:hover': { bgcolor: '#6a1b7a' }, fontWeight: 700, mb: 3 }}
        >
          {walletData.credit_balance <= 0
            ? 'No credit available'
            : useSubmitting ? 'Applying…' : 'Apply credit'}
        </Button>

        <Divider sx={{ mb: 2 }} />

        {/* Ledger history */}
        <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
          <History fontSize="small" /> Credit history
        </Typography>

        {walletData.ledger.length === 0 ? (
          <Typography variant="body2" color="text.secondary" fontStyle="italic">
            No credit activity yet.
          </Typography>
        ) : (
          <List disablePadding sx={{ maxHeight: 260, overflowY: 'auto' }}>

            {walletData.ledger.slice().reverse().map((entry, idx) => {
              const label =
                entry.type === 'issued' ? 'Credit issued'
                : entry.type === 'used' ? 'Credit used'
                : 'Paid to distributor';
              const chipLabel = entry.type === 'issued' ? '+' : '−';
              const chipColor = entry.type === 'issued' ? 'success' : entry.type === 'paid_out' ? 'error' : 'warning';
              const amountColor = entry.type === 'paid_out' ? '#C62828' : 'inherit';
              return (
                <ListItem key={idx} divider sx={{ px: 0 }}>
                  <ListItemIcon sx={{ minWidth: 40 }}>
                    <Chip size="small" label={chipLabel} color={chipColor} />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <Stack direction="row" justifyContent="space-between">
                        <Typography variant="body2" fontWeight={600}>{label}</Typography>
                        <Typography variant="body2" fontWeight={700} sx={{ color: amountColor }}>
                          {entry.type === 'paid_out' ? `-${money(entry.amount)}` : money(entry.amount)}
                        </Typography>
                      </Stack>
                    }
                    secondary={
                      <Typography variant="caption" color="text.secondary">
                        {entry.source_return_id && `From return ${entry.source_return_id}`}
                        {entry.used_against_po && `Applied to PO ${entry.used_against_po}`}
                        {entry.notes ? ` · ${entry.notes}` : ''}
                      </Typography>
                    }
                  />
                </ListItem>
              );
            })}
          </List>
        )}
      </>
    )}
  </DialogContent>

  <DialogActions sx={{ p: 2 }}>
    <Button onClick={() => setWalletDialog(false)} variant="outlined" sx={{ borderColor: '#006D77', color: '#006D77' }}>
      Close
    </Button>
  </DialogActions>
</Dialog>

      {/* Snackbar for notifications */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default DistributorList;